import React, { Fragment } from "react";
import ReportTitleSection from "../../../../libraries/ReportGenerator/ReportTitleSection";
import { switchReportStyle } from "../../Timps/Switch/style/index";
import { themeService } from "../../../../theme/service/activeTheme.service";
import ReportFraInfoSectionContainer from "../../../../libraries/ReportGenerator/ReportFraInfoSection";
import { ReportGroupingUtils } from "../../utils/reportGroupingUtils";
import ReportTableSectionRenderer from "../../../../libraries/ReportGenerator";
import { SpecialKeyValComboBox } from "../../SFRTA/TrackDisturbanceReport";
import { EqualContentsRow } from "../../../../libraries/ReportGenerator/EqualContentsRow";
import { getRowsList } from "./LocomotiveSchema.jsx";
import { SignatureImageImproved } from "../../utils/SignatureImage.jsx";
import { getSupportingDocuments } from "../AirBrakeReports/AirBrakeReports/CommonFunctions.jsx";

export const LomotiveInspection33daysReport = (props) => {
  const { reportData } = props;

  let reportsByDateAndUser = ReportGroupingUtils.groupReportsByDateAndUser(reportData);
  // let removeDuplicates = ReportGroupingUtils.RemoveDuplicateTestCodesFromGroupedReport(reportsByDateAndUser);
  let decodedReports = ReportGroupingUtils.decodeTestsInReportGroups(reportsByDateAndUser);

  return (
    <React.Fragment>
      {decodedReports.map((report, i) => {
        return (
          <div key={i} className="mainContent table-report last-page-break-print" style={{ ...themeService(switchReportStyle.mainStyle) }}>
            <ReportView key={i} data={report} {...props} />
          </div>
        );
      })}
    </React.Fragment>
  );
};

const groupNotesData = (summary) => {
  let NOTES = {};
  if (summary.addNotes) {
    for (let note of summary.addNotes) {
      const { notes, selectitem } = note;
      if (notes && selectitem) {
        if (!NOTES[`${selectitem}_notes`]) NOTES[`${selectitem}_notes`] = "";
        NOTES[`${selectitem}_notes`] += notes + "\t";
      }
    }
  }

  return NOTES;
};

const ReportView = (props) => {
  const { data } = props;
  const { decodedData, fraHeaderInfo } = data;
  // let tableRows =
  return (
    <React.Fragment>
      {decodedData.map((singleReport, index) => {
        let notes = groupNotesData(singleReport.summary);
        return (
          <div index={index}>
            <ReportTitleSection title={"33 Days Locomotive Inspection Report"} fontSizeOverride={"35px"} />
            <ReportFraInfoSectionContainer {...props} />
            <span className="spacer"></span>

            <table className="table-bordered">
              {getRowsList(singleReport.summary).map((e, i) => (
                <ReportTableSectionRenderer rowsData={{ ...singleReport.summary, ...notes }} section={e} key={i} />
              ))}
            </table>
            <table className="table-bordered">
              <ReportTableSectionRenderer
                rowsData={{ ...singleReport.summary }}
                section={{
                  heights: { header1: "100px" },
                  classes: { header2: "" },
                  inlineData: true,
                  columns: [
                    {
                      title: "Defects Repaired",
                      colSpan: 2,
                      rowSpan: 1,
                      topAlign: true,
                      leftAlign: true,
                      className: "tbl-text-normal",
                      accessor: "defRepaired",
                    },
                  ],
                }}
              />
            </table>
            {Object.keys(singleReport.summary).includes("supportingDocuments") && getSupportingDocuments(singleReport.summary)}
            <table className="table-bordered">
              <ReportTableSectionRenderer
                rowsData={{ ...singleReport.summary }}
                section={{
                  heights: { header1: "40px" },
                  classes: { header2: "" },
                  inlineData: true,
                  columns: [
                    {
                      title: "Signature of Person Performing Inspection",
                      colSpan: 4,
                      rowSpan: 1,
                      topAlign: true,
                      leftAlign: true,
                      className: "tbl-text-normal",
                      accessor: "",
                      isTitleOnly: true,
                    },
                    {
                      title: "INSPECTION:",
                      colSpan: 6,
                      rowSpan: 1,
                      centerAlign: true,
                      leftAlign: true,
                      className: "tbl-text-normal",
                      accessor: "",
                      isValueOnly: true,
                      formatter: () => {
                        return <SignatureImageImproved signatureImage={fraHeaderInfo.signatureImage} width={"500px"} />;
                      },
                    },
                  ],
                }}
              />
            </table>

            {/* <table className="table-bordered">
            <ReportTableSectionRenderer
              rowsData={{ ...singleReport.summary }}
              section={{
                heights: { header1: "40px" },
                classes: { header2: "" },
                inlineData: true,
                columns: [
                  {
                    title: "Signature of Person Performing Repairs",
                    colSpan: 4,
                    rowSpan: 1,
                    topAlign: true,
                    leftAlign: true,
                    className: "tbl-text-normal",
                    accessor: "",
                    isTitleOnly: true,
                  },
                  {
                    title: "INSPECTION:",
                    colSpan: 6,
                    rowSpan: 1,
                    centerAlign: true,
                    leftAlign: true,
                    className: "tbl-text-normal",
                    accessor: "sigPerformingRepairs",
                    formatter: (value) => {
                      return <SignatureImageImproved signatureImage={value} width={"500px"} />;
                    },
                    isValueOnly: true,
                  },
                ],
              }}
            />
          </table> */}
          </div>
        );
      })}
    </React.Fragment>
  );
};



// WEBPACK FOOTER //
// ./src/components/Reports/ReVAMP/LomotiveInspection33days/LomotiveInspection33days.jsx